// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@assets/shop/daily_bg_idle.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("@assets/shop/item_title_bg_blue.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("@assets/shop/blue_box_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("@assets/shop/count_box_bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.purchase-dialog-container {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 100% 100%;
    box-sizing: border-box;
    padding: 12px;
    display: flex;
    flex-direction: column;
    gap: 6px;
    align-items: center;
}

.purchase-dialog-title {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: 100% 100%;
    width: 100%;
    padding: 8px 0;
    display: flex;
    justify-content: center;
}

.purchase-dialog-title span {
    font-size: 16px;
    font-weight: 400;
    color: #ffffff;
}

.purchase-dialog-frame {
    width: 84px;
    height: 84px;
    border-radius: 8px;
}

.purchase-dialog-button-container {
    display: flex;
    justify-content: flex-end;
    gap: 4px;
    width: 100%;
    padding-bottom: 4px;
}

.purchase-dialog-button-container button {
    background: transparent;
    border: 1px solid #244752;
    border-radius: 4px;
    padding: 4px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    color: #ffffff;
    min-width: 92px;
}

.purchase-dialog-button-container button:hover {
    border: 1px solid #71deff;
}

.purchase-dialog-button-container button img {
    width: 10px;
    height: 10px;
    margin-right: 4px;
}

.purchase-dialog-price {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
}

.purchase-dialog-price img {
    width: 18px;
    height: 18px;
}

.purchase-dialog-price span {
    font-size: 14px;
    color: #ffffff;
}

.purchase-count-container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
}

.purchase-count-button {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-size: 100% 100%;
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
    color: #ffffff;
    cursor: pointer;
}

.purchase-count {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-size: 100% 100%;
    padding: 8px 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/components/purchaseDialog/PurchaseDialog.style.css"],"names":[],"mappings":"AAAA;IACI,yDAAuD;IACvD,0BAA0B;IAC1B,sBAAsB;IACtB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,yDAA4D;IAC5D,0BAA0B;IAC1B,WAAW;IACX,cAAc;IACd,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,QAAQ;IACR,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,yDAAqD;IACrD,0BAA0B;IAC1B,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,yDAAsD;IACtD,0BAA0B;IAC1B,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,eAAe;AACnB","sourcesContent":[".purchase-dialog-container {\n    background-image: url('@assets/shop/daily_bg_idle.png');\n    background-size: 100% 100%;\n    box-sizing: border-box;\n    padding: 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    align-items: center;\n}\n\n.purchase-dialog-title {\n    background-image: url('@assets/shop/item_title_bg_blue.png');\n    background-size: 100% 100%;\n    width: 100%;\n    padding: 8px 0;\n    display: flex;\n    justify-content: center;\n}\n\n.purchase-dialog-title span {\n    font-size: 16px;\n    font-weight: 400;\n    color: #ffffff;\n}\n\n.purchase-dialog-frame {\n    width: 84px;\n    height: 84px;\n    border-radius: 8px;\n}\n\n.purchase-dialog-button-container {\n    display: flex;\n    justify-content: flex-end;\n    gap: 4px;\n    width: 100%;\n    padding-bottom: 4px;\n}\n\n.purchase-dialog-button-container button {\n    background: transparent;\n    border: 1px solid #244752;\n    border-radius: 4px;\n    padding: 4px;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 16px;\n    color: #ffffff;\n    min-width: 92px;\n}\n\n.purchase-dialog-button-container button:hover {\n    border: 1px solid #71deff;\n}\n\n.purchase-dialog-button-container button img {\n    width: 10px;\n    height: 10px;\n    margin-right: 4px;\n}\n\n.purchase-dialog-price {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 4px;\n}\n\n.purchase-dialog-price img {\n    width: 18px;\n    height: 18px;\n}\n\n.purchase-dialog-price span {\n    font-size: 14px;\n    color: #ffffff;\n}\n\n.purchase-count-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 4px;\n}\n\n.purchase-count-button {\n    background-image: url('@assets/shop/blue_box_bg.png');\n    background-size: 100% 100%;\n    width: 24px;\n    height: 24px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-weight: 600;\n    color: #ffffff;\n    cursor: pointer;\n}\n\n.purchase-count {\n    background-image: url('@assets/shop/count_box_bg.png');\n    background-size: 100% 100%;\n    padding: 8px 14px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: #ffffff;\n    font-size: 12px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
